import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import axios from 'axios';
import i18n from "@/helpers/i18n";

export interface State {
    badges: any[],
    allCount: number,
    loading: boolean,
    loadingBadge: boolean;
    badge: any,
}

const defaultState: State = {
    badges: [],
    allCount: 0,
    loading: false,
    loadingBadge: false,
    badge: {},
};

const getters = {
    loading: (state: State) => state.loading,
    loadingBadge: (state: State) => state.loadingBadge,
    badges: (state: State) => state.badges,
    allCount: (state: State) => state.allCount,
    badge: (state: State) => state.badge,
}

const mutations: MutationTree<State> = {
    setBadges(state: State, payload: any[]) {
        state.badges = payload;
    },
    setAllCount(state: State, payload: number) {
        state.allCount = payload
    },
    setLoadStatus(state: State, payload: boolean) {
        state.loading = payload
    },
    setBadge(state: State, payload: any) {
        state.badge = payload
    },
    editBadge(state: State, payload: any) {
        const elem:any = {
            barcode:payload.barcode,
            _id:payload._id,
            status:payload.status,
            name:payload.name.first + ' ' + payload.name.last,
            role:payload.role,
            contacts:payload.contacts
        }
        state.badges = state.badges.map((el: any) =>  el._id == elem._id ? elem : el )
    }
}

const actions: ActionTree<State, RootState> = {
    async loadBadgesFromServer({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        try {
            const {data} = await axios.get('/v5/show/' + payload.showCode + '/badge?' +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&per-page=' + payload.itemsPerPage + payload.filter)
            if (data.error) {
                throw (data.error)
            }
            data.data.models.map((badge: any) => {
                badge.phones = badge.contacts.filter((contact: any) => contact.type == 'phone')
                badge.email = badge.contacts.filter((contact: any) => contact.type == 'email')
                return badge
            })
            commit('setBadges', data.data.models)
            commit('setAllCount', data.data.allCount)
            commit('setLoadStatus', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            commit('setLoadStatus', false)
        }
    },
    async loadBadgeFromServer({state, commit}, payload: string) {
        try {
            state.loadingBadge = true
            const {data} = await axios.get('/v5/admin/badge/' + payload)
            commit('setBadge', data.data.badge)
            state.loadingBadge = false
        } catch (e) {
            state.loadingBadge = false
        } finally {
            state.loadingBadge = false
        }
    },
    async editBadgeFromServer({state, commit}, payload: any) {
        try {
            state.loadingBadge = true
            const {data} = await axios.patch('/v5/badge/' + payload.badgeId, payload.params)
            commit('setBadge', data.data.badge)
            commit('editBadge', data.data.badge)
            state.loadingBadge = false
        } catch (e) {
            state.loadingBadge = false
        } finally {
            state.loadingBadge = false
        }
    },
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
